import { useEffect, useMemo, useState } from "react";

const COLS = 12;
const ROWS = 6;

/**
 * Image slider where each slide dissolves into a grid of small tiles
 * and the next slide reassembles from tiles back into a whole image.
 */
export default function PixelSlider({ images, cycleSeconds = 5, className = "" }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (images.length < 2) return undefined;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, cycleSeconds * 1000);
    return () => clearInterval(id);
  }, [images.length, cycleSeconds]);

  const tiles = useMemo(() => {
    const arr = [];
    for (let r = 0; r < ROWS; r++) {
      for (let c = 0; c < COLS; c++) {
        arr.push({ r, c, delay: (r + c) * 22 });
      }
    }
    return arr;
  }, []);

  return (
    <div className={`px-slider ${className}`}>
      {images.map((img, i) => (
        <div
          key={img.src}
          className={`px-slider-frame${i === index ? " active" : ""}`}
          style={{ zIndex: i === index ? 2 : 1 }}
          aria-hidden={i !== index}
        >
          {tiles.map((t, ti) => (
            <span
              key={ti}
              className="px-tile"
              style={{
                backgroundImage: `url(${img.src})`,
                backgroundSize: `${COLS * 100}% ${ROWS * 100}%`,
                backgroundPosition: `${(t.c / (COLS - 1)) * 100}% ${(t.r / (ROWS - 1)) * 100}%`,
                transitionDelay: `${t.delay}ms`,
              }}
            />
          ))}
        </div>
      ))}
      <img className="px-slider-a11y-img" src={images[index].src} alt={images[index].alt} />
      {images.length > 1 && (
        <div className="img-slider-dots">
          {images.map((img, i) => (
            <button
              key={img.src}
              type="button"
              className={`img-slider-dot${i === index ? " active" : ""}`}
              aria-label={`Show image ${i + 1}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
